import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoginPayload, LoginResponse } from '../models/auth.models';
import { environment } from '../../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly http = inject(HttpClient);

  login(payload: LoginPayload) {
    return this.http.post<LoginResponse>(API_URL + routes.login, payload);
  }
}

const routes = {
  login: '/api/v1/user/identity/account/token',
};
